import Axios, { AxiosInstance, AxiosRequestConfig } from 'axios'

export const THIRD_PARTY_API_TIMEOUT_MS = 15_000

export const createThirdPartyApiClient = (config: AxiosRequestConfig = {}): AxiosInstance => {
  return Axios.create({
    timeout: THIRD_PARTY_API_TIMEOUT_MS,
    ...config,
  })
}
